import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-emerald-500/15',
    borderColor: 'border-emerald-500/40',
    textColor: 'text-emerald-300',
    emoji: '🟢',
    title: 'Evaluación y Ambiente',
    subtitle: 'Base Sólida',
    desc: 'Evaluación de reforzadores, perfil de aprendizaje, estructura del ambiente terapéutico, primeras sesiones y construcción del vínculo clínico.'
  }, {
    id: 2,
    lightColor: 'bg-yellow-500/15',
    borderColor: 'border-yellow-500/40',
    textColor: 'text-yellow-300',
    emoji: '🟡',
    title: 'Comunicación Funcional',
    subtitle: 'Voz y Sistemas',
    desc: 'Las 6 operantes verbales, protocolo PECS completo de 6 fases, evaluación comunicativa, sistemas CAA disponibles en Argentina, agendas visuales y entrenamiento familiar.'
  }, {
    id: 3,
    lightColor: 'bg-orange-500/15',
    borderColor: 'border-orange-500/40',
    textColor: 'text-orange-300',
    emoji: '🟠',
    title: 'Conducta Desafiante',
    subtitle: 'Protocolo y Crisis',
    desc: 'Análisis funcional completo, las 4 funciones en profundidad, Plan de Intervención Conductual (PIC), protocolo de crisis por fases, conductas específicas: agresión, autolesión, fuga y rabieta.'
  }, {
    id: 4,
    lightColor: 'bg-cyan-500/15',
    borderColor: 'border-cyan-400/40',
    textColor: 'text-cyan-300',
    emoji: '🔵',
    title: 'Habilidades Sociales',
    subtitle: 'Conexión y Juego',
    desc: 'Niveles del juego con protocolo, habilidades sociales básicas a avanzadas, Social Stories completas, guiones sociales, video modeling, grupos de habilidades y coordinación con pares.'
  }, {
    id: 5,
    lightColor: 'bg-purple-500/15',
    borderColor: 'border-purple-500/40',
    textColor: 'text-purple-300',
    emoji: '🟣',
    title: 'Autonomía y Vida Diaria',
    subtitle: 'Independencia',
    desc: '20 task analysis completos: higiene, vestido, alimentación, control de esfínteres, rutinas del hogar y comunidad. Protocolo de entrenamiento familiar y autonomía escolar.'
  }, {
    id: 6,
    lightColor: 'bg-amber-500/15',
    borderColor: 'border-amber-500/40',
    textColor: 'text-amber-300',
    emoji: '⭐',
    title: 'Registros y Documentación',
    subtitle: 'Sistema Completo',
    desc: 'Planillas de sesión, gráficas de progreso, análisis de datos, informes para Obra Social, informe de evaluación inicial, informe de alta, consentimiento informado y gestión completa de la historia clínica.'
  }];
  return <section className="py-20 bg-cyan-900" data-id="element-325">
      <div className="container mx-auto px-4" data-id="element-326">
        <div className="text-center mb-16" data-id="element-327">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-400/20 text-cyan-200 border border-cyan-400/30 font-bold mb-6 text-[16px]" data-id="element-328">
            🧠 CENTRALPACK™ MEGAPACK ABA LISTO
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-329">
            6 Tomos + 4 Bonos
          </h2>
          <p className="text-cyan-100 font-medium text-[16px]" data-id="element-330">
            Del caos clínico a la intervención con sistema. 360+ páginas — Todo
            resuelto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-331">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-cyan-800 bg-cyan-950/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-cyan-700 transition-all flex flex-col h-full" data-id="element-332">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-333">
                <div className="text-2xl" data-id="element-334">{tomo.emoji}</div>
                <div data-id="element-335">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-336">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-337">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-338">
                <p className="font-semibold text-cyan-200 mb-3 pb-3 border-b border-cyan-800/60" data-id="element-339">
                  {tomo.subtitle}
                </p>
                <p className="text-cyan-100 text-sm leading-relaxed" data-id="element-340">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}